/* global Localize */
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import {
	Button,
	Form,
	Segment,
	Header,
	Container,
	Checkbox,
	Icon,
	Dropdown,
	Modal,
	Grid,
	Divider,
	List
} from 'semantic-ui-react'
import Input from 'components/InputForm'
import { supplierLogin, setLanguage } from 'store/actions/app'
import LogoImg from '../../images/iconWhite.png'
import backgroundLogin from '../../images/backgroundLogin.png' 
import backgroundLoginMovil from '../../images/backgroundMovil.png' 
import { validateLogoToken } from 'store/actions/sys_companys'
import { useWindowDimensions } from 'semantic-table/dist/components/WindowSize'

const SupplierLogin = (props) => {
	const [openModal, setOpenModal] = useState(false)
	const [openModalPassword, setOpenModalPassword] = useState(false)
	const [logoToken, setLogoToken] = useState(null)
	const { width } = useWindowDimensions()
	const [logoUrl, setLogoUrl] = useState(null)
	const logoImageUrl = logoToken ? logoUrl : LogoImg

	const [user, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

	// Use the current language from props or default to English
	const currentLang = props.lang || 'en'

	const labels = {
		es:
		{
			header: 'Sitio del Proveedor',
			description: 'Iniciar Sesión',
			usernameLabel: 'Correo electrónico',
			passwordLabel: 'Contraseña',
			loginButton: 'Iniciar Sesión',
		},
		en:
		{
			header: 'Provider Site',
			description: 'Log in',
			usernameLabel: 'Email',
			passwordLabel: 'Password',
			loginButton: 'Log in',
		},
		pt:
		{
			header: 'Site do Fornecedor',
			description: 'Iniciar sessão',
			usernameLabel: 'E-mail',
			passwordLabel: 'Senha',
			loginButton: 'Entrar',
		},
		ar:
		{
			header: 'موقع المورد',
			description: 'تسجيل الدخول',
			usernameLabel: 'بريد إلكتروني',
			passwordLabel: 'كلمة المرور',
			loginButton: 'تسجيل الدخول',
		}
		// Add labels for other languages as needed
	};
	useEffect(() => {
		const fetchData = async () => {
			const urlParams = new URLSearchParams(window.location.search)
			const token = urlParams.get('e')

			if (token) {
				setLogoToken(token)
				try {
					const logoUrl = await props.validateLogoToken(token)
					console.log('Logo URL in LoginRoute:', logoUrl)
					setLogoUrl(logoUrl)
				} catch (error) {
					console.error('Error validating logo token:', error.message)
					// You can handle the error here according to your needs
				}
			}
		}

		if (typeof Localize !== 'undefined' && Localize.showWidget) {
			Localize.showWidget()
		}

		fetchData()
	}, [props])

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	const handleSubmit = (e) => {
		e.preventDefault()
		props.supplierLogin({ user, password })
	}

	const containerStyle = {
		minHeight: '100vh',
		display: 'flex',
		flexDirection: isMobile ? 'column' : 'row',
		background: isMobile ? `url(${backgroundLoginMovil})`: `url(${backgroundLogin})`,
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		backgroundAttachment: 'fixed',
	}

	return (
		<div style={containerStyle}>
			{/* Right Section */}
			<Container
				style={{
					flex: isMobile ? 'none' : 1,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					padding: isMobile ? '1rem' : '2rem',
					minHeight: isMobile ? 'auto' : '100vh',
				}}
			>
				<Segment
					style={{
						background: 'rgba(255, 255, 255, 0.1)',
						backdropFilter: 'blur(8px)',
						padding: isMobile ? '1.5rem' : '2rem',
						width: '100%',
						maxWidth: '400px',
					}}
				>
					{(process.env.REACT_APP_LOGO_LOGIN_URL ?? logoImageUrl) && (
						<div style={{ textAlign: 'center', marginBottom: '1rem' }}>
							<img src={process.env.REACT_APP_LOGO_LOGIN_URL ?? logoImageUrl} alt="Logo" style={{ maxWidth: '120px', filter: 'drop-shadow(1px 1px 2rem white)' }} />
						</div>
					)}
					<Header
						as="h2"
						style={{
							color: 'white',
							marginBottom: '2rem',
							textAlign: isMobile ? 'center' : 'left'
						}}
					>
						<Container textAlign="center" style={{ marginTop: '2rem', color: 'white' }}>
							{/* <a href="#" style={{ color: 'white' }}>{labels[currentLang].termsOfService}</a> */}
							{/* {labels[currentLang].description} */}
							{/* {'  '} | {'  '} */}
							{/* <a href="#" style={{ color: 'white' }}>{labels[currentLang].privacyPolicy}</a> */}
							{labels[currentLang].header}
						</Container>
						{/* {labels[currentLang].signIn}{"                     "} */}
						{/* {labels[currentLang].header} */}
					</Header>
					<Form size="large" onSubmit={handleSubmit}>
						<Form.Field>
							<Form.Input
								fluid
								type="email"
								value={user}
								icon={<Icon name='user' style={{ color: 'gray' }} />}
								iconPosition='left'
								onChange={(e) => setEmail(e.target.value)}
								placeholder={labels[currentLang].usernameLabel}
							/>
						</Form.Field>
						<Form.Field>
							<Form.Input
								fluid
								type="password"
								value={password}
								icon={<Icon name='lock' style={{ color: 'gray' }} />}
								iconPosition='left'
								onChange={(e) => setPassword(e.target.value)}
								placeholder={labels[currentLang].passwordLabel}
							/>
						</Form.Field>
						{/* <Form.Field>
			  <Checkbox
				label={<label style={{ color: 'white' }}>{labels[currentLang].rememberMe}</label>}
				checked={rememberMe}
				onChange={(e, data) => setRememberMe(data.checked)}
			  />
			</Form.Field> */}
						<Button fluid primary type="submit" style={{ marginBottom: '1rem' }}>
							{labels[currentLang].loginButton}
						</Button>
					</Form>
					<Container
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'flex-end',
						}}
					>
						<Button
							icon='question'
							circular
							color='black'
							type='button'
							onClick={() => {
								setOpenModal(!openModal)
							}}
						/>
					</Container>
				</Segment>
			</Container>
			<Modal
				closeIcon
				basic
				centered={true}
				onClose={() => setOpenModal(false)}
				onOpen={() => setOpenModal(true)}
				open={openModal}
				size='large'
			>
				<Modal.Content content>
					<Segment inverted style={{ height: '100%' }}>
						<Grid stackable divided inverted>
							<Grid.Row columns={2}>
								<Grid.Column
									width={6}
									verticalAlign='middle'
									textAlign='center'
								>
									<Header inverted content='© Geologistic GPS 2025' />
								</Grid.Column>
								<Grid.Column width={8}>
									<Header inverted content='Contacto' />
									<Divider></Divider>
									<Header
										size='small'
										inverted
										content='¿Necesitas registrar un nuevo ticket o solicitud?'
									/>
									<List divided inverted>
										<List.Item
											header='Ingresa al Portal: '
											content='https://geologistic.com.mx/Soporte/'
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open(
													'https://geologistic.com.mx/Soporte/',
													'_blank'
												)
											}}
										/>
										<List.Item
											header='Soporte'
											content='(686) 214 5447, (686) 385 6938,  (686) 510 9915'
										/>
										<List.Item header='Oficina' content='(686) 372 9877' />
										<List.Item
											header='Emergencias'
											content='(686) 420 3333, (686) 214 5447, (686) 385 6938, (686) 510 9915,  (686) 123 6454'
										/>
										<List.Item
											header='Administración'
											content='(686) 122 0316'
										/>
										<List.Item
											header='Ventas'
											content='(686) 510 9915, (686) 196 4736, (686) 420 8586,  (686) 191 1571'
										/>
									</List>
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</Segment>
				</Modal.Content>
			</Modal>
		</div>
	)
}

const mapStateToProps = (state) => ({
	lang: state.app?.lang
})

const mapDispatchToProps = (dispatch) => ({
	supplierLogin: (parmas) => dispatch(supplierLogin(parmas)),
	validateLogoToken: (logoToken) => dispatch(validateLogoToken(logoToken)),
	setLanguage: (lang) => dispatch(setLanguage(lang))
})

export default connect(mapStateToProps, mapDispatchToProps)(SupplierLogin)